import { JobStartDateAmount } from './job-start-date-amount.model';

export interface TransferComplianceManPowerDetails {
  ManPowerDetailIDs: Array<string>;
  ComplianceIDFrom?: string;
  ComplianceIDTo?: string;
  ManPowerReqID?: string;
  JobStartDates: Array<JobStartDateAmount>;
  OnSite: boolean;
}
